import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';
import './OtherDocs.scss';
import { useErrorsContext } from '../../../../contexts/ErrorsContext';
import { useEffect, useState } from 'react';
import { Button, Loading, NavMenu } from '../../../../components';
import { useParametrics } from '../../../../contexts/ParametricsContext';
import { PetitionCard } from '../../../../components/petitionCard/PetitionCard';
import { getManagerAdditionalDocsProcedures } from '../../../../services/procedureServices';
import { OtherDocCard } from './OtherDocCard/OtherDocCard';

const OtherDocs = () => {

  const { t } = useTranslation();
  const { convocation, convocationId } = useParametrics();
  const { showError } = useErrorsContext();
  const history = useHistory();
  const location = useLocation();

  const [loading, setLoading] = useState(true);
  const [petition, setPetition] = useState(null);
  const [otherDocs, setOtherDocs] = useState(null);

  const _getManagerAdditionalDocs = async () => {
    try {
      setLoading(true);
      const resp = await getManagerAdditionalDocsProcedures(petition.petitionId);
      setOtherDocs(resp);
    } catch (e) {
      showError(e);
    }
    finally{
      setLoading(false);
    }
  }

  useEffect(() => {
    if(!convocationId) return;
    if(!location?.state?.petition) {
      return history.replace('/petitions')
    }
    setPetition(location.state.petition);
  }, [convocationId]);

  useEffect(() => {
    if(petition) _getManagerAdditionalDocs();
  }, [petition])
  
  return (
    <NavMenu>
      <div className="OtherDocs">
        <div className="content">
          {
            loading ? (
              <div className='vh-100 d-flex justify-content-center align-items-center'>
                <Loading />
              </div>
            ) : (
              <>
                <div className="w-100 d-flex justify-content-center">
                  <div className="header">
                    <Button
                      icon="/misc/icons/arrow-left-blue.svg"
                      action={() => history.goBack()}
                      className="p-2 button-only-icon me-2"
                      a11y={t('Globals.return')}
                    />
                    <h1>{t('Petitions.OtherDocs.title')} </h1>
                  </div>
                </div>
                <div className="petitions">
                  <PetitionCard convocationTitle={convocation?.title} petition={petition} isButton={false}/>
                </div>
                
                <div className="otherDocs">
                  {
                    otherDocs.map((addDoc) => {
                      return (
                        <OtherDocCard
                          key={addDoc.id}
                          petition={petition}
                          addDoc={addDoc}
                        />
                      )
                    })
                  }
                </div>
              </>
            )
          }
        </div>
      </div>
    </NavMenu>
  );
}

export default OtherDocs;